import React from "react";
import WindowedSelect from "react-windowed-select";
import { makeStyles } from '@material-ui/core/styles';
import { createFilter } from "react-windowed-select";

const useStyles = makeStyles(theme => ({
  input: {
    fontFamily: 'inherit',
    // position: 'absolute',
    marginLeft: '0px',
    marginTop: theme.spacing(1),
    minWidth: '100%',
  }
}));

const customFilter = createFilter({ ignoreAccents: false });

export default function CustomSelect({options, handleChange, value, label, placeholder, disabled}) {
  const classes = useStyles();

  return (
    <WindowedSelect
      isDisabled={disabled}
      filterOption={customFilter}
      options={options}
      className={classes.input}
      onChange={handleChange}
      value={value}
      placeholder={`${label}`}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: base => ({ ...base, zIndex: 9999 }) ,
        option: (base) => ({
          ...base,
          zIndex: 100,
          height: 40,
          borderRadius: 5,
          fontSize: 12,
          fontFamily: 'Roboto',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis'
        })
      }}
    />
  );
}